/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdWebFeaturesFtlIntegrationLauncherDownloadRequestRequest interface.
 */
export function instanceOfFxIdWebFeaturesFtlIntegrationLauncherDownloadRequestRequest(value) {
    if (!('OriginUrl' in value) || value['OriginUrl'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesFtlIntegrationLauncherDownloadRequestRequestFromJSON(json) {
    return FxIdWebFeaturesFtlIntegrationLauncherDownloadRequestRequestFromJSONTyped(json, false);
}
export function FxIdWebFeaturesFtlIntegrationLauncherDownloadRequestRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'OriginUrl': json['OriginUrl'],
    };
}
export function FxIdWebFeaturesFtlIntegrationLauncherDownloadRequestRequestToJSON(json) {
    return FxIdWebFeaturesFtlIntegrationLauncherDownloadRequestRequestToJSONTyped(json, false);
}
export function FxIdWebFeaturesFtlIntegrationLauncherDownloadRequestRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'OriginUrl': value['OriginUrl'],
    };
}
//# sourceMappingURL=FxIdWebFeaturesFtlIntegrationLauncherDownloadRequestRequest.js.map